import './filter-toggle.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

import ToggleField from '../toggle-field'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    label: string
    checked: boolean
    onChange: (checked: boolean) => void
  }
>

const FilterToggle = ({className, label, checked, onChange, ...props}: Props) => (
  <div {...props} className={cn('FilterToggle', {checked}, className)}>
    <ToggleField checked={checked} onChange={onChange} invert />
    <div className="FilterToggle__label">{label}</div>
  </div>
)

export default FilterToggle
